import {loadStripe} from "@stripe/stripe-js"
import axios from "axios";

const form = document.getElementById('checkout-form')

if (form) {
    const stripe = await loadStripe(form.dataset.stripePublicKey)
    const elements = stripe.elements({
        clientSecret: form.dataset.clientSecret
    })

    const paymentElement = elements.create('payment')
    const csrfErrorMsgDiv = document.getElementById('csrf-error-msg')
    const stripeErrorMsgDiv = document.getElementById('error-message')
    paymentElement.mount("#checkout-element")

    form.addEventListener('submit', async (evt) => {
        evt.preventDefault()
        csrfErrorMsgDiv.classList.add('hidden')
        stripeErrorMsgDiv.innerText = ''

        try {
            await axios.post(
                form.dataset.csrfUrl,
                new FormData(form)
            )
        } catch (e) {
            csrfErrorMsgDiv.classList.remove('hidden')
            return
        }

        const {error} = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: form.dataset.returnUrl
            }
        })

        if (error) {
            document.getElementById('error-message').innerText = error.message
        }
    })
}
